import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["search", "filter"]
  static values = { url: String, currentSort: String }

  connect() {
    this.timeout = null
  }

  search(event) {
    clearTimeout(this.timeout)
    if (event?.key === 'Enter') {
      this.filter()
      return
    }
    this.timeout = setTimeout(() => this.filter(), 500)
  }

  filter(page = null) {
    const url = new URL(this.urlValue, window.location.origin)
    const params = new URLSearchParams(url.search)

    params.set('search', this.hasSearchTarget ? this.searchTarget.value : '')
    params.set('sort', this.currentSortValue || '')

    if (this.hasFilterTarget) {
      params.set('filter', this.filterTarget.value)
    }

    if (page) {
      params.set('page', page)
    }

    fetch(`${url.pathname}?${params}`, {
      headers: {
        'Accept': 'text/vnd.turbo-stream.html'
      }
    })
      .then(response => response.text())
      .then(html => Turbo.renderStreamMessage(html))
  }

  sort(event) {
    event.preventDefault()
    const sortElement = event.target.closest('[data-sort]')
    if (sortElement) {
      this.currentSortValue = sortElement.dataset.sort
      this.filter()
    }
  }

  clear(event) {
    event.preventDefault()
    if (this.hasSearchTarget) {
      this.searchTarget.value = ''
    }
    if (this.hasFilterTarget) {
      this.filterTarget.selectedIndex = 0
    }
    this.filter()
  }
}
